const ONBOARDING_ROUTE_ROOT = "/dashboard/onboarding";

export enum ONBOARDING_ROUTES {
  Status = `${ONBOARDING_ROUTE_ROOT}/status`,
  PersonalInfo = `${ONBOARDING_ROUTE_ROOT}/personal-info`,
  UploadLoanDocs_1 = `${ONBOARDING_ROUTE_ROOT}/upload-loan-docs/1`,
  UploadLoanDocs_2 = `${ONBOARDING_ROUTE_ROOT}/upload-loan-docs/2`,
  UploadLoanDocs_3 = `${ONBOARDING_ROUTE_ROOT}/upload-loan-docs/3`,
  UploadBankDocs_1 = `${ONBOARDING_ROUTE_ROOT}/upload-bank-docs/1`,
  // UploadBankDocs_2 = `${ONBOARDING_ROUTE_ROOT}/upload-bank-docs/2`,
  ChoosePlan = `${ONBOARDING_ROUTE_ROOT}/choose-plan`,
  SignContract = `${ONBOARDING_ROUTE_ROOT}/sign-contract`,
  FinishOnboarding = `${ONBOARDING_ROUTE_ROOT}/finish-onboarding`,
}
